/**
 * Service layer configuration.
 * All services use real API endpoints.
 */

/** When true, fetch facilities after login (e.g. on facility-selection). */
export const FETCH_FACILITIES_AFTER_LOGIN =
  process.env.REACT_APP_FETCH_FACILITIES_AFTER_LOGIN === 'true';
